import { State } from '../../interfaces/State';
import { LearningMode } from '../reducers/learningMode';

export const selectLearningMode = (state: State): LearningMode => {
  return state.get('learningMode');
};
